import { createContext, useContext } from 'react';
export var CONTEXT_VERSION = 1;
export var LeafletContext = /*#__PURE__*/createContext(null);
export var LeafletProvider = LeafletContext.Provider;
export function useLeafletContext() {
  var context = useContext(LeafletContext);
  if (context == null) {
    throw new Error('No context provided: useLeafletContext() can only be used in a descendant of <MapContainer>');
  }
  return context;
}